import SizzaImg from "../images/projects/sizza.png";
import FlashC from "../images/projects/flash.png";
import Pol from "../images/projects/pol.png";
import Todo from "../images/projects/todo.png";
import Chipi from "../images/projects/chipi.png";

const projects = [
  {
    name: "Chipi Online (Affiliate Marketing Website)",
    img: Chipi,
    description:
      "Built an Amazon Affiliate e-commerce site using Next.js, MongoDB, GraphQL, and TypeScript. Seamlessly showcasing products with a user-friendly interface. Leveraged Vercel for optimal deployment.",
    type: "Web",
  },
  {
    name: "SizzaSneaks E-commerce Platform",
    img: SizzaImg,
    description:
      "This project involved building front-end and back-end applications using the ReactJS and NodeJS, connecting these applications using RESTful HTTP based API's.",
    type: "Web",
  },
  {
    name: "Potential Outlived Website Integrated with E-Mail Campaign",
    img: Pol,
    description:
      "I was approached with the opportunity to design and build the Potential Outlived Website which serves as the home of this brand's digital footprint. In addition, the website required integration with a MailChimp account, in order to facilitate email campaigns.",
    type: "Web",
  },
  // {
  //   name: "Todoey App (Note Taking)",
  //   img: Todo,
  //   description: "A note taking application built using Flutter Framework.",
  //   type: "Mobile",
  // },
  // {
  //   name: "Flash Chat (Instant Messaging)",
  //   img: FlashC,
  //   description:
  //     "An instant messaging application built using Flutter and Firebase by Google. Firebase Authentication is used to handle authentication, while Firebase Cloud Firestore is used to store all communication data.",
  //   type: "Mobile",
  // },
];

export default projects;
